

//```import saga efects
import { all, call, fork, put, takeEvery } from 'redux-saga/effects';

//```import Error Manager
import { ExceptionManager } from 'Core/logManager';

//```import constants types
import {
    PACKAGES_FEATURES_SEARCH_ROLE_MODULES_REQUEST,
    PACKAGES_FEATURES_SEARCH_ROLE_MODULES_BY_ID_REQUEST,
    PACKAGES_FEATURES_UPDATE_ROLE_MODULES_REQUEST
} from 'Redux/actionTypes';

import { endpoints } from 'Core/defaultValues';
import {
    packagesFeaturesSearchRoleModulesResult,
    packagesFeaturesSearchRoleModulesByIdResult,
    packagesFeaturesUpdateRoleModulesResult,
} from 'Redux/actions';
import { clientQuery, clientMutation } from 'Core/data/GraphQLApi';

function* searchTemplateRoleModules({ payload }) {
    try {
        let QUERY = `
            query searchModules ($conditions: [ModuleSearchInput], $sort: [ModuleSortInput], $limit: Int, $offset: Int) {
                result: searchModules (conditions: $conditions, sort: $sort, limit: $limit, offset: $offset) {
                    items {
                        id
                        projectId
                        code
                        userCode
                        name
                        groupName
                        parentModuleId
                        category
                        modulesCount
                        validationLevel
                        parentModuleName
                        description
                        availablePermissions
                    }
                    total
                }
            }
        `;

        let data = yield call(
            clientQuery,
            QUERY,
            {
                conditions: {
                    fields: ["projectId"],
                    terms: [payload],
                    exact: true
                },
                sort: {
                    field: "name",
                    order: "ASC"
                },
                limit: 1000,
                offset: 0
            },
            endpoints.GRAPHQL_GENERAL,
        );

        if (data?.result) {
            const { items } = data?.result;
            let newItems = items.map((item) => ({ ...item, r: false, c: false, u: false, d: false }));
            newItems = newItems && newItems.length > 0 ? newItems.filter((item) => item?.validationLevel !== "Subuser" && item?.validationLevel !== "None") : [];
            yield put(packagesFeaturesSearchRoleModulesResult(newItems))
        } else yield put(packagesFeaturesSearchRoleModulesResult([]))

    } catch (exc) {
        yield put(packagesFeaturesSearchRoleModulesResult([]))
        ExceptionManager(exc, 'Modules/packages/.components/featureTab/redux/saga', 'searchTemplateRoleModules');
    }
}

function* searchRoleModulesById({ payload }) {
    try {
        let QUERY = `
            query searchRoleModules ($conditions: [RoleModuleSearchInput], $sort: [RoleModuleSortInput], $limit: Int, $offset: Int) {
                result: searchRoleModules (conditions: $conditions, sort: $sort, limit: $limit, offset: $offset) {
                    items {
                        id
                        roleId
                        moduleId
                        module {
                            id
                            projectId
                            code
                            userCode
                            name
                            groupName
                            parentModuleId
                            category
                            modulesCount
                        }
                        c
                        u
                        d
                        isDefault
                    }
                    total
                }
            }
        `;

        let data = yield call(
            clientQuery,
            QUERY,
            {
                conditions: [
                    {
                        fields: ["roleId"],
                        terms: [payload],
                        exact: true
                    }
                ],
                sort: {
                    field: "module_name",
                    order: "ASC"
                },
                limit: 2000,
                offset: 0
            },
            endpoints.GRAPHQL_GENERAL,
        );

        if (data?.result) {
            const { items } = data?.result;
            yield put(packagesFeaturesSearchRoleModulesByIdResult(items))
        } else yield put(packagesFeaturesSearchRoleModulesByIdResult([]))

    } catch (exc) {
        yield put(packagesFeaturesSearchRoleModulesByIdResult([]))
        ExceptionManager(exc, 'Modules/packages/.components/featureTab/redux/saga', 'searchRoleModulesById');
    }
}

function* updateRole({ payload }) {
    try {
        let QUERY = `
            mutation updateRole ($id: Int!, $name: String, $description: String, $permissions: [PermissionInput]) {
                result: updateRole (id: $id, name: $name, description: $description, permissions: $permissions) {
                    id
                    projectId
                    name
                    description
                    roleModules {
                        id
                        roleId
                        moduleId
                        module {
                            id
                            projectId
                            code
                            userCode
                            name
                            groupName
                            parentModuleId
                            category
                            modulesCount
                        }
                        c
                        u
                        d
                        isDefault
                    }
                }
            }
        `;
        let data = yield call(
            clientMutation,
            QUERY,
            payload,
            endpoints.GRAPHQL_GENERAL,
        );
        yield put(packagesFeaturesUpdateRoleModulesResult(data.result))
    } catch (exc) {
        yield put(packagesFeaturesUpdateRoleModulesResult({ error: true }))
        ExceptionManager(exc, 'Modules/packages/.components/featureTab/redux/saga', 'updateRole');
    }
}

function* watchMethods() {
    yield takeEvery(PACKAGES_FEATURES_SEARCH_ROLE_MODULES_REQUEST, searchTemplateRoleModules);
    yield takeEvery(PACKAGES_FEATURES_SEARCH_ROLE_MODULES_BY_ID_REQUEST, searchRoleModulesById);
    yield takeEvery(PACKAGES_FEATURES_UPDATE_ROLE_MODULES_REQUEST, updateRole);
}

export default function* rootSaga() {
    yield all([fork(watchMethods)]);
}